import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

export const NavLink = ({ to, children, className = '' }: NavLinkProps) => {
  const location = useLocation();
  const isActive = location.pathname === to || location.pathname.startsWith(to + '/');
  
  return (
    <Link 
      to={to} 
      className={`nav-item ${isActive ? 'active' : ''} ${className}`}
    >
      {children}
    </Link>
  );
};

export const ReaderNavLinks = () => (
  <>
    <NavLink to="/home">Home</NavLink>
    <NavLink to="/trending">Explore</NavLink>
    <NavLink to="/authors">Authors</NavLink>
  </>
);

export const JournalistNavLinks = () => (
  <>
    <NavLink to="/dashboard">Dashboard</NavLink>
    <NavLink to="/dashboard/content">Articles</NavLink>
    <NavLink to="/dashboard/audience">Audience</NavLink>
    <NavLink to="/dashboard/earnings">Earnings</NavLink>
  </>
);

const HeaderNavLinks: React.FC = () => {
  return (
    <div className="flex space-x-6">
      <ReaderNavLinks />
    </div>
  );
};

export default HeaderNavLinks;
